var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Purchases>Vendors>Create New Vendor>Bank Details",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1000,
    transform: "translate(-272 -451)",
    fill: "#EDEDF7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2507",
    x: -32,
    y: -317,
    width: 1680,
    height: 868,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 33278"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2492",
    x: -12.5,
    y: -15.5,
    width: 603,
    height: 151,
    fill: "#F6F6F9",
    stroke: "#E5E6E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 33277"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2506",
    opacity: 0.2,
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "#3B58FF",
    stroke: "#3B58FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.46453 22.0625C8.24321 22.0625 8.04291 22.1964 7.95881 22.4022L7.04034 24.6519C6.97173 24.8201 6.99165 25.0115 7.09235 25.162C7.19415 25.3136 7.36346 25.4044 7.54606 25.4044H24.5264H24.5253C24.7079 25.4044 24.8772 25.3136 24.979 25.162C25.0797 25.0115 25.0996 24.8201 25.031 24.6519L24.1126 22.4022C24.0285 22.1964 23.8282 22.0625 23.6068 22.0625H8.46453ZM8.83081 23.1547H23.2395L23.712 24.3122H8.35716L8.83081 23.1547Z",
    fill: "#3B58FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.913 12.6738C14.612 12.6738 14.3674 12.9184 14.3674 13.2194V22.5967C14.3674 22.8988 14.612 23.1422 14.913 23.1422H17.1638C17.4648 23.1422 17.7093 22.8977 17.7093 22.5967V13.2194C17.7093 12.9184 17.4648 12.6738 17.1638 12.6738H14.913ZM15.4585 13.766H16.616V22.051H15.4585V13.766Z",
    fill: "#3B58FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.79823 12.6738C9.49725 12.6738 9.25269 12.9184 9.25269 13.2194V22.5967C9.25269 22.8977 9.49724 23.1422 9.79823 23.1422H12.0479C12.35 23.1422 12.5946 22.8988 12.5946 22.5967V13.2194C12.5946 12.9184 12.35 12.6738 12.0479 12.6738H9.79823ZM10.3438 13.766H11.5013V22.051H10.3438V13.766Z",
    fill: "#3B58FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.0291 12.6738C19.727 12.6738 19.4824 12.9184 19.4824 13.2194V22.5967C19.4824 22.8977 19.727 23.1422 20.0291 23.1422H22.2788C22.5797 23.1422 22.8243 22.8977 22.8243 22.5967V13.2194C22.8243 12.9184 22.5797 12.6738 22.2788 12.6738H20.0291ZM20.5746 13.766H21.7332V22.051H20.5746V13.766Z",
    fill: "#3B58FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.0375 7C15.959 7 15.8815 7.0166 15.8107 7.04869L7.3198 10.9141C7.12504 11.0026 7 11.1974 7 11.411V13.2014C7 13.5024 7.24455 13.747 7.54665 13.747H24.527H24.5259C24.828 13.747 25.0726 13.5024 25.0726 13.2014V11.411C25.0726 11.1974 24.9475 11.0026 24.7528 10.9141L16.263 7.04869C16.1922 7.0166 16.115 7 16.0375 7ZM16.0375 8.14532L23.9817 11.7617V12.6547H8.09339V11.7617L16.0375 8.14532Z",
    fill: "#3B58FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.2107 9.32683C14.4261 9.77943 14.1528 10.7986 14.6054 11.5831C15.058 12.3677 16.0771 12.641 16.8617 12.1873C17.6462 11.7347 17.9196 10.7156 17.4659 9.93102C17.0132 9.14646 15.9941 8.87312 15.2095 9.32683H15.2107ZM15.7562 10.2729C16.0295 10.1147 16.3637 10.2043 16.5208 10.4777C16.6791 10.751 16.5895 11.0852 16.3161 11.2423C16.0428 11.4005 15.7097 11.3109 15.5515 11.0376C15.3932 10.7643 15.4829 10.4312 15.7562 10.2729Z",
    fill: "#3B58FF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1000,
    fill: "white",
    transform: "translate(-272 -451)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bankIcon.55b761f0567e73d3f78983ff9fdb088c.svg";
export { ForwardRef as ReactComponent };